import React, { Component } from "react";
import config from "../config";
import Search from "../Search/Search";
import SavedPalettes from "../SavedPalettes/Saved-Palettes";
import TokenService from "../services/token-service";
import "./generator.css";

class Generator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      generator: true,
      savedPalettes: false,
    };
  }
  generatorView() {
    this.setState({ generator: true, savedPalettes: false });
  }
  savedView() {
    this.setState({ generator: false, savedPalettes: true });
  }
  render() {
    const token = TokenService.hasAuthToken();
    return (
      <>
        {token ? (
          <div className="tab-view">
            <div
              className={this.state.generator ? "active-tab" : ""}
              onClick={() => {
                this.generatorView();
              }}
            >
              Generator
            </div>
            <div
              className={this.state.savedPalettes ? "active-tab" : ""}
              onClick={() => {
                this.savedView();
              }}
            >
              Saved Palettes
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.generator ? <Search /> : <SavedPalettes />}
      </>
    );
  }
}

export default Generator;
